import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
      'Copy .env.example to .env.local and fill in your Supabase project values.',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-dubs-client': 'web',
    },
  },
});

export type SupabaseClient = typeof supabase;

/**
 * Build a unique realtime channel name.
 *
 * Why this exists: React 19 StrictMode (dev) double-mounts effects. Our
 * cleanup path is `removeChannel()` which is async, so a second mount can
 * fire before the first channel is fully removed. Calling `.channel(name)`
 * with a name that matches an already-subscribed channel returns the same
 * channel instance — and `.on()` then throws "cannot add callbacks after
 * subscribe()". Appending a random suffix guarantees every mount gets a
 * fresh channel.
 */
export function channelName(base: string): string {
  return `${base}:${Math.random().toString(36).slice(2, 10)}`;
}
